import { createStore } from "vuex";
import axios           from "axios";


axios.defaults.headers.common = {
    'X-Requested-With' : 'XMLHttpRequest',
    'X-CSRF-TOKEN'     : document.querySelector( 'meta[name="csrf-token"]' ).getAttribute( 'content' ),
};


let state =
        {
            copydeck : false,

            mode : 'login',

            authenticated : false,
            currentUser   : null,
            token         : null,
            audienceMode  : "jeunes",

            formErrors : [],

            isRegistered      : false,
            hasBecomeLoggedIn : false,

            open : false,

            resendConfirmation: "",

            blockedMode : false,

        };

let getters =
        {
            comments ( state )
            {
                return state.comments;
            },

            isAutheticated ( state )
            {
                return typeof state.authenticated !== 'undefined' && state.authenticated;
            },


            currentUser ( state )
            {
                return state.currentUser;
            },

            userToken ( state )
            {
                return state.token;
            },

            currentPostReactions ( state )
            {
                return state.mainPostReactions;
            },

            isRegistered ( state )
            {
                return state.isRegistered;
            },

            hasBecomeLoggedIn ( state )
            {
                return state.hasBecomeLoggedIn;
            },

            audienceMode ( state )
            {
                return state.audienceMode;
            },

            isPageBlocked ( state )
            {
                return state.blockedMode;
            },
        };


let actions =
        {

            async copydeck ( { commit } )
            {
                let response = await axios.get( "/endpoints/copydeck-login" );


                commit( "copydeck", response.data );
            },


            async userInfo ( { commit, state }, payload )
            {

                const { postType, postId } = payload;

                let response = await axios.get( "/endpoints/userinfo" );


                commit( "updateRelatedDataInStore", response.data );
            },


            mainContentInfo ( { commit, state }, payload )
            {
                commit( "mainContentInfo", payload );
            },
        }


let mutations =
        {


            ready ( state )
            {
                state.ready = true;
            },


            copydeck ( state, payload )
            {
                state.copydeck = payload;
            },


            changeMode ( state, payload )
            {
                state.mode = payload;
            },

            changeAudience ( state, payload )
            {
                state.audienceMode = payload;
            },

            changeBlockedMode ( state, payload )
            {
                state.blockedMode = payload;
            },


            mainContentInfo ( state, payload )
            {

                state.mainContentType = payload.mainContentType;
                state.mainContentId   = payload.mainContentId;
                state.reactionsOnly   = payload.reactionsOnly;


            },


            authenticateUser ( state, payload )
            {

                state.authenticated = true;
                state.token         = payload.token;
                state.currentUser   = payload.user;
                ////console.log('store mutator authenticateUser', data);
            },

            setRegistered ( state, payload )
            {
                state.isRegistered = true;
            },

            hasBecomeLoggedIn ( state, payload )
            {
                state.hasBecomeLoggedIn = true;
            },

            addErrors ( state, payload )
            {
                state.formErrors = payload;
            },

            removeError ( state, payload )
            {

                let formErrors = Object.entries( state.formErrors );
                let cleaned    = formErrors.filter( ( [ key, value ] ) => key !== payload );

                state.formErrors = Object.fromEntries( cleaned );


            },


            openModal ( state )
            {
                state.open = true;
            },
            closeModal ( state )
            {
                state.open = false;
            },

            resendConfirmation ( state, payload)
            {
                state.resendConfirmation = payload;
            },

            resendMessage ( state, payload)
            {
                state.resendMessage = payload;
            }
        }


export default createStore( { state, getters, actions, mutations } );
